import {
  CONSOLE_LIST_REQUEST,
  CONSOLE_LIST_SUCCESS,
  CONSOLE_LIST_FAIL,
  CONSOLE_DETAILS_REQUEST,
  CONSOLE_DETAILS_SUCCESS,
  CONSOLE_DETAILS_FAIL,
  CONSOLE_CREATE_REQUEST,
  CONSOLE_CREATE_SUCCESS,
  CONSOLE_CREATE_FAIL,
  CONSOLE_CREATE_ACKNOWLEDGE,
  CONSOLE_DELETE_REQUEST,
  CONSOLE_DELETE_SUCCESS,
  CONSOLE_DELETE_FAIL,
  CONSOLE_ITEM_LIST_REQUEST,
  CONSOLE_ITEM_LIST_SUCCESS,
  CONSOLE_ITEM_LIST_FAIL,
  CONSOLE_ITEM_DETAILS_REQUEST,
  CONSOLE_ITEM_DETAILS_SUCCESS,
  CONSOLE_ITEM_DETAILS_FAIL,
  CONSOLE_ITEM_CREATE_REQUEST,
  CONSOLE_ITEM_CREATE_SUCCESS,
  CONSOLE_ITEM_CREATE_FAIL,
  CONSOLE_ITEM_CREATE_ACKNOWLEDGE,
  CONSOLE_ITEM_UPDATE_REQUEST,
  CONSOLE_ITEM_UPDATE_SUCCESS,
  CONSOLE_ITEM_UPDATE_FAIL,
  CONSOLE_ITEM_UPDATE_ACKNOWLEDGE,
  CONSOLE_ITEM_DELETE_REQUEST,
  CONSOLE_ITEM_DELETE_SUCCESS,
  CONSOLE_ITEM_DELETE_FAIL,
  LIST_ITEM_ADD_REQUEST,
  LIST_ITEM_ADD_SUCCESS,
  LIST_ITEM_ADD_FAIL,
  LIST_ITEM_UPDATE_REQUEST,
  LIST_ITEM_UPDATE_SUCCESS,
  LIST_ITEM_UPDATE_FAIL,
  LIST_ITEM_DELETE_REQUEST,
  LIST_ITEM_DELETE_SUCCESS,
  LIST_ITEM_DELETE_FAIL,
} from '../constants/consoleConstants';

// Console list reducer
export const consoleListReducer = (state = { consoles: [] }, action) => {
  switch (action.type) {
    case CONSOLE_LIST_REQUEST:
      return { loading: true, consoles: [] };
    case CONSOLE_LIST_SUCCESS:
      return { loading: false, consoles: action.payload };
    case CONSOLE_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Console details reducer
export const consoleDetailsReducer = (state = { console: {} }, action) => {
  switch (action.type) {
    case CONSOLE_DETAILS_REQUEST:
      return { loading: true, ...state };
    case CONSOLE_DETAILS_SUCCESS:
      return { loading: false, console: action.payload };
    case CONSOLE_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Console create reducer
export const consoleCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case CONSOLE_CREATE_REQUEST:
      return { loading: true };
    case CONSOLE_CREATE_SUCCESS:
      return { loading: false, success: true, console: action.payload };
    case CONSOLE_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case CONSOLE_CREATE_ACKNOWLEDGE:
      return {};
    default:
      return state;
  }
};

// Console delete reducer
export const consoleDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case CONSOLE_DELETE_REQUEST:
      return { loading: true };
    case CONSOLE_DELETE_SUCCESS:
      return { loading: false, success: true };
    case CONSOLE_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Console item list reducer
export const consoleItemListReducer = (state = { items: [] }, action) => {
  switch (action.type) {
    case CONSOLE_ITEM_LIST_REQUEST:
      // Keep current items so a refresh after editing doesn't blank the page
      return { loading: true, items: state.items || [] };
    case CONSOLE_ITEM_LIST_SUCCESS:
      return { loading: false, items: action.payload };
    case CONSOLE_ITEM_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Console item details reducer
export const consoleItemDetailsReducer = (state = { item: {} }, action) => {
  switch (action.type) {
    case CONSOLE_ITEM_DETAILS_REQUEST:
      return { loading: true, ...state };
    case CONSOLE_ITEM_DETAILS_SUCCESS:
      return { loading: false, item: action.payload };
    case CONSOLE_ITEM_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Console item create reducer
export const consoleItemCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case CONSOLE_ITEM_CREATE_REQUEST:
      return { loading: true };
    case CONSOLE_ITEM_CREATE_SUCCESS:
      return { loading: false, success: true, item: action.payload };
    case CONSOLE_ITEM_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case CONSOLE_ITEM_CREATE_ACKNOWLEDGE:
      return {};
    default:
      return state;
  }
};

// Console item update reducer
export const consoleItemUpdateReducer = (state = { item: {} }, action) => {
  switch (action.type) {
    case CONSOLE_ITEM_UPDATE_REQUEST:
      return { loading: true };
    case CONSOLE_ITEM_UPDATE_SUCCESS:
      return { loading: false, success: true, item: action.payload };
    case CONSOLE_ITEM_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case CONSOLE_ITEM_UPDATE_ACKNOWLEDGE:
      return { item: {} };
    default:
      return state;
  }
};

// Console item delete reducer
export const consoleItemDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case CONSOLE_ITEM_DELETE_REQUEST:
      return { loading: true };
    case CONSOLE_ITEM_DELETE_SUCCESS:
      return { loading: false, success: true };
    case CONSOLE_ITEM_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// List item add reducer
export const listItemAddReducer = (state = {}, action) => {
  switch (action.type) {
    case LIST_ITEM_ADD_REQUEST:
      return { loading: true };
    case LIST_ITEM_ADD_SUCCESS:
      return { loading: false, success: true, item: action.payload };
    case LIST_ITEM_ADD_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// List item update reducer
export const listItemUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case LIST_ITEM_UPDATE_REQUEST:
      return { loading: true };
    case LIST_ITEM_UPDATE_SUCCESS:
      return { loading: false, success: true, item: action.payload };
    case LIST_ITEM_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// List item delete reducer
export const listItemDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case LIST_ITEM_DELETE_REQUEST:
      return { loading: true };
    case LIST_ITEM_DELETE_SUCCESS:
      return { loading: false, success: true };
    case LIST_ITEM_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
